function customHeight() {
  const jbAccordion = document.querySelectorAll(".jb-accordion");

  jbAccordion.forEach((item) => {
    let itemContent = item.querySelector(".jb-accordion-content");
    if (itemContent) {
      // Get the height of the content
      let contentHeight = itemContent.scrollHeight;

      // Store the height as a data attribute
      itemContent.setAttribute("data-height", contentHeight);

      // Initially set the height to 0 to hide the content
      itemContent.style.height = "0";

      // Add click listener to the item to toggle the height
      item.addEventListener("click", () => {
        // Check if the content is expanded or collapsed
        if (itemContent.style.height === "0px" || itemContent.style.height === "") {
          // Expand: Set height to the original content height
          itemContent.style.height = `${contentHeight}px`;
          item.classList.add("open");
        } else {
          // Collapse: Set height to 0
          item.classList.remove("open");
          itemContent.style.height = "0";
        }
      });
    }
  });

  console.log("handleProductAccordions");
}
function ProductAccordions() {
  const sectionAcordion = document.querySelector(".main-product__details-wrapper");

  if (!sectionAcordion || sectionAcordion.classList.contains("custom-height")) {
    return;
  }

  sectionAcordion.classList.add("custom-height");

  // gett= all accordions content
  const accordions = sectionAcordion.querySelectorAll(".accordion__inner");
  accordions.forEach((accordion) => {
    accordion.addEventListener("click", (e) => {
      // add open attribue to the accordion

      accordion.removeAttribute("open");
      var contentWrap = accordion.querySelector(".accordion__content");
      var accordionsContent = accordion.querySelector(".accordion__content p");
      var childElements = contentWrap.children;

      // Calculate the total height of child elements
      var totalHeight = Array.from(childElements).reduce((acc, child) => {
        return acc + child.clientHeight;
      }, 0);

      console.log(totalHeight);

      accordion.classList.toggle("active");

      if (accordion.classList.contains("active")) {
        contentWrap.style.height = totalHeight + 150 + "px";
      } else {
        contentWrap.style.height = "0px";
      }
    });
  });

  console.log("handleProductAccordions");
}

customHeight();
// ProductAccordions();
